export class MessageFormattingService {
    static setMessagesMeta(response, { setLastInTheGroup, setAiGenerated, setIsReady } = {}) {
        if (response && response.elements && Array.isArray(response.elements)) {
            response.elements = response.elements.map((element, index) => {
                const lastMessageInGroup = index === response.elements.length - 1;

                return {
                    ...element,
                    id: new Date().getTime() + index,
                    responseId: response.id,
                    ...setLastInTheGroup ? { lastMessageInGroup } : {},
                    ...lastMessageInGroup && setAiGenerated ? { aiGenerated: lastMessageInGroup && this.isAiGeneratedMessage(response.elements) } : {},
                    ...lastMessageInGroup && setIsReady ? { isReady: true } : {}
                };
            });
        }

        return response;
    }

    static processResponses(responses, config = {}) {
        if (responses && responses.length !== 0) {
            responses.forEach((response) => response = this.setMessagesMeta(response, config));
        }

        return responses;
    }

    static isAiGeneratedMessage(messages) {
        return messages.some(message =>
            message.payload && message.payload.style === 'generated'
        );
    }

    static createMessageObject({ type, text, html, cards, isScrollAnchor, source, links, lastInTheGroup }) {
        return {
            id: new Date().getTime(),
            type,
            source,
            isScrollAnchor,
            lastInTheGroup,
            payload: {
                html,
                text,
                links,
                cards
            },
        };
    }

    static streamMessagesWithTypeWriterEffect(state, newMessages, token, currentMessageIndex = 0) {
        if (currentMessageIndex >= newMessages.length) {
            newMessages.forEach(message => message.isReady = true);
            return;
        }


        const currentMessage = newMessages[currentMessageIndex];

        if (currentMessage.type === 'text' || currentMessage.type === 'html') {
            const content = currentMessage.payload.text || currentMessage.payload.html;
            let charIndex = 0;
            this.typewriter({ state, charIndex, content, currentMessage, newMessages, token, currentMessageIndex, typewriterSpeed: 2 });
        } else {
            state.messages = [...state.messages, currentMessage];
            this.streamMessagesWithTypeWriterEffect(state, newMessages, token, currentMessageIndex + 1);
        }
    }

    static typewriter(payload) {
        if (payload.state.typeWriterToken !== payload.token) return;

        if (payload.charIndex < payload.content.length) {
            const nextChunk = this.getNextChunk(payload.content, payload.charIndex);
            const partialMessage = {
                ...payload.currentMessage,
                payload: {
                    ...payload.currentMessage.payload,
                    ...(payload.currentMessage.type === 'html' ? {
                        html: payload.content.slice(0, payload.charIndex + nextChunk.length)
                    } : {
                        text: payload.content.slice(0, payload.charIndex + nextChunk.length)
                    })
                }
            };

            payload.state.messages = [
                ...(payload.charIndex === 0 ? payload.state.messages : payload.state.messages.slice(0, -1)),
                partialMessage
            ];

            payload.charIndex += nextChunk.length;
            setTimeout(() => this.typewriter(payload), payload.typewriterSpeed);
        } else {
            payload.state.messages = [...payload.state.messages.slice(0, -1), payload.currentMessage];
            this.streamMessagesWithTypeWriterEffect(payload.state, payload.newMessages, payload.token, payload.currentMessageIndex + 1);
        }
    }

    static getNextChunk(content, startIndex) {
        const tagRegex = /^<\/?[a-zA-Z][\w\-]*(?:\s+[a-zA-Z_:][\w\-:.]*(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s"'=<>`]+))?)*\s*\/?>/;
        const remainingContent = content.slice(startIndex);

        const match = remainingContent.match(tagRegex);
        if (match) {
            return match[0];
        }

        return remainingContent[0];
    }

    static createMessageCards(hits) {
        return this.createMessageObject({
            type: 'cards',
            cards: hits,
            text: undefined,
            isScrollAnchor: false,
            source: 'bot',
            links: undefined,
            lastInTheGroup: true
        });
    }
}